// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1TTDI","label":"Radio_label__1KAUL","checkMark":"Radio_checkMark__orGhn","disabled":"Radio_disabled__1FfDY"};